import { AdminRouteGate } from 'components/Global/AdminRouteGate';
import { AuthLayout } from 'components/Global/AuthLayout';
import { DraftMedicinesRequestRouteGate } from 'components/Global/DraftMedicinesRequestRouteGate';
import { CombosRouteGate } from 'components/Global/CombosRouteGate';
import GlobalLayout from 'layouts/Global';
import { ForgotPassword, Login, ResetPassword } from 'pages';
import AccessDeniedPage from 'pages/AccessDeniedPage';
import { Categories } from 'pages/Categories';
import { Dashboard } from 'pages/Dashboard';
import { DraftMedicinesRequest } from 'pages/DraftMedicinesRequest';
import { DoseForm } from 'pages/DoseForm';
import { CategoryDoseFormMapping } from 'pages/CategoryDoseFormMapping';
import { Medicines } from 'pages/Medicines';
import { Combos } from 'pages/Combos';
import { Groceries } from 'pages/Groceries';
import { GroceryCategories } from 'pages/GroceryCategories';
import { GrocerySubCategories } from 'pages/GrocerySubCategories';
import { GroceryQualityCheck } from 'pages/GroceryQualityCheck';
import { GroceryRejected } from 'pages/GroceryRejected';
import { Rejected } from 'pages/Rejected';
import PageNotFoundPage from 'pages/PageNotFound';
import { QualityCheck } from 'pages/QualityCheck';
import { Roles } from 'pages/Settings/Roles';
import Settings from 'pages/Settings/Settings';
import { Users } from 'pages/Settings/Users';
import { ImportData } from 'pages/Settings/ImportData';
import { Staff } from 'pages/Settings/Staff';
import { SubCategories } from 'pages/SubCategories';
import { WarningTags } from 'pages/WarningTags';


import { createBrowserRouter } from 'react-router-dom';

const router = createBrowserRouter([
	{
		element: <AuthLayout />,
		children: [
			{
				path: '/',
				element: <GlobalLayout />,
				children: [
					{
						index: true,
						element: <Dashboard />,
					},
					{
						path: '/quality-check',
						element: <QualityCheck />,
					},
					{
						path: '/medicines',
						element: <Medicines />,
					},
					{
						path: '/combos',
						element: (
							<CombosRouteGate>
								<Combos />
							</CombosRouteGate>
						),
					},
					{
						path: '/grocery-quality-check',
						element: <GroceryQualityCheck />,
					},
					{
						path: '/groceries',
						element: <Groceries />,
					},
					{
						path: '/grocery-rejected',
						element: <GroceryRejected />,
					},
					{
						path: '/grocery-categories',
						element: <GroceryCategories />,
					},
					{
						path: '/grocery-sub-categories',
						element: <GrocerySubCategories />,
					},
					{
						path: '/draft-medicines-request',
						element: (
							<DraftMedicinesRequestRouteGate>
								<DraftMedicinesRequest />
							</DraftMedicinesRequestRouteGate>
						),
					},
					{
						path: '/rejected',
						element: <Rejected />,
					},
					{
						path: '/categories',
						element: <Categories />,
					},
					{
						path: '/sub-categories',
						element: <SubCategories />,
					},
					{
						path: '/warning-tags',
						element: <WarningTags />,
					},
					{
						path: '/dose-form',
						element: <DoseForm />,
					},
					{
						path: '/category-dose-form-mapping',
						element: <CategoryDoseFormMapping />,
					},
				],
			},
			{
				path: '/settings',
				element: <Settings />,
				children: [
					{
						index: true,
						path: 'users',
						element: <Users />,
					},
					{
						path: 'roles',
						element: <Roles />,
					},
					{
						path: 'staff',
						element: <Staff />,
					},
					{
						path: 'import-data',
						element: (
							<AdminRouteGate>
								<ImportData />
							</AdminRouteGate>
						),
					},
				]
			},
			{
				element: <Login />,
				path: '/login',
			},
			{
				path: '/reset-password',
				element: <ResetPassword />,
			},
			{
				path: '/set-password',
				element: <ResetPassword />,
			},
			{
				path: '/forgot-password',
				element: <ForgotPassword />,
			},
			{
				path: '/access-denied',
				element: <AccessDeniedPage />,
			},
		],
	},
	{
		path: '*',
		element: <PageNotFoundPage />,
	},
]);

export default router;
